<script setup>
import { computed } from 'vue'

const props = defineProps({
    selectedItems: {
        type: Set,
        required: true,
    },
})

const emit = defineEmits([
    'clear-selection',
    'add-to-list',
    'create-list',
])

const itemCount = computed(() => props.selectedItems.size)

const handleClearSelection = () => {
    emit('clear-selection')
}

const handleAddToList = () => {
    emit('add-to-list')
}

const handleCreateList = () => {
    emit('create-list')
}
</script>

<template>
    <div
        v-if="itemCount > 0"
        class="bulk-actions-footer text-center"
    >
        <div class="footer-content">
            <div class="selection-chip">
                <span class="selection-count">
                    {{ itemCount }} TAMer<span v-if="itemCount > 1">s</span> selected
                </span>
                <button
                    class="clear-btn"
                    @click="handleClearSelection"
                >
                    <img
                        src="@/assets/img/cancel-01.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                </button>
            </div>
            <div class="action-buttons">
                <button
                    class="action-btn"
                    @click="handleAddToList"
                >
                    <img
                        src="@/assets/img/add.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <span>Add to List</span>
                </button>
                <button
                    class="action-btn"
                    @click="handleCreateList"
                >
                    <img
                        src="@/assets/img/menu-01.png"
                        style="width: 20px; cursor: pointer"
                        alt=""
                    />
                    <span>Create a new list</span>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.bulk-actions-footer {
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    z-index: 100;
    position: fixed !important;
    bottom: 30px !important;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    width: fit-content;
    max-width: 1200px;
}

.footer-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
}

.selection-chip {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    padding: 6px 12px;
    border-radius: 20px;
}

.selection-count {
    font-weight: 500;
    margin-right: 8px;
}

.clear-btn {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.action-buttons {
    display: flex;
    gap: 10px;
}

.action-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.action-btn:hover {
    background-color: #f0f0f0;
}
</style>
